import { render } from "./produkHukum.vue?vue&type=template&id=e4d2a2b0"
import script from "./produkHukum.vue?vue&type=script&lang=js"
export * from "./produkHukum.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__